module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css",
      "integrity": "sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3 row"
  }, [_c('div', {
    staticClass: "col-3 nowrap"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.dateMove(-1)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day"
    },
    on: {
      "change": _vm.getOrders
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-right",
      "circle": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.dateMove(1)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.rooms && _vm.rooms.length) ? _c('el-button-group', _vm._l((_vm.rooms), function(room) {
    return _c('el-button', {
      key: room._id,
      attrs: {
        "type": room._id === (_vm.selectedRoom && _vm.selectedRoom._id) ? 'primary' : '',
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.selectRoom(room)
        }
      }
    }, [_vm._v(_vm._s(room.title))])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3 nowrap"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-left",
      "circle": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.timeMove(-15)
      }
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      "placeholder": "Select time"
    },
    model: {
      value: (_vm.selectedTime),
      callback: function($$v) {
        _vm.selectedTime = $$v
      },
      expression: "selectedTime"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-right",
      "circle": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.timeMove(15)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.selectedRoom) ? _c('view-room', {
    attrs: {
      "rooms": _vm.rooms,
      "orders": _vm.orders,
      "time": _vm.selectedTime,
      "room": _vm.selectedRoom
    },
    on: {
      "new-order": _vm.createNewOrder,
      "edit-order": _vm.editOrder
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.newOrder._id ? 'Editing of order' : 'Create new order',
      "visible": _vm.showNewOrder
    },
    on: {
      "update:visible": function($event) {
        _vm.showNewOrder = $event
      }
    }
  }, [(_vm.loadingOrder) ? _c('div', [_vm._v("\n      Loading...\n    ")]) : _c('div', [(_vm.newOrder) ? _c('div', [_c('create-order-dialog', {
    attrs: {
      "rooms": _vm.rooms,
      "item": _vm.newOrder
    },
    on: {
      "create": _vm.onCreateOrder,
      "deleted": _vm.onCreateOrder,
      "cancel": _vm.onCreateOrder
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55111446"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Reservations.vue
// module id = 431
// module chunks = 4